import React, { useState, useEffect } from "react";
import useDataSourceManager from "hooks/useDataSourceManager";
import { v4 as uuidv4 } from "uuid";
import { useTheme } from "@mui/material/styles";
import { Box, Typography, CircularProgress } from "@mui/material";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";
import ModalContainer from "components/ModalContainer";
import { ErrorNotification } from "pages/System/UserManagement/ErrorHandle";

const ResendModal = (props) => {
  const {
    openResendModal,
    handleCloseResendModal,
    selectedRowData,
    entId,
    getListEnterpriseUsers,
    getListPendingEnterpriseUsers,
  } = props;
  const theme = useTheme();

  const [updateUuid, setUpdateUuid] = useState(uuidv4());
  const [errorMessageHandleModal, setErrorMessageHandleModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [actionModal, setActionModal] = useState(false);
  const [resendEmailOkModal, setResendEmailOkModal] = useState(false);
  const { dataMap, getData, decodeTokenData, sendRequest, sendBatch } =
    useDataSourceManager();

  const resendEmail = () => {
    setIsLoading(true);
    sendRequest("ents/:entId/invitations/:invitationId.resend", updateUuid, {
      entId,
      invitationId: selectedRowData.invitationId,
    });
  };

  useEffect(() => {
    const resendResponse = getData(updateUuid);
    if (!resendResponse) {
      return;
    }

    setIsLoading(false);

    if (resendResponse?.code === 400) {
      setActionModal(true);
      setErrorMessage(resendResponse?.message);
    } else {
      setResendEmailOkModal(true);
      getListEnterpriseUsers();
      /* getListPendingEnterpriseUsers(); */
      handleCloseResendModal();
    }
  }, [dataMap]);

  return (
    <>
      <ModalContainer display={openResendModal} modalWidth="500px">
        {isLoading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255,255,255,0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <CircularProgress sx={{ color: theme.palette.primary.mainHover }} />
          </Box>
        )}
        <Box style={{ display: "flex", justifyContent: "center" }}>
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
              letterSpacing: "-1",
            }}
          >
            Resend verification Email
          </Typography>
        </Box>
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "10px",
          }}
        >
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[3],
              fontFamily: theme.typography.fontFamily,
              textAlign: "center",
            }}
          >
            Are you sure you want to send a verification email to{" "}
            <Box
              component="span"
              sx={{ fontWeight: theme.typography.customFontWeight[1] }}
            >
              {selectedRowData?.email}
            </Box>
            ?
          </Typography>
        </Box>

        <Box
          sx={{
            paddingTop: "30px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <OutlineButton
            onClick={handleCloseResendModal}
            sx={{ marginRight: "20px" }}
            width="100px"
            height="32px"
          >
            Cancel
          </OutlineButton>
          <SolidButton onClick={resendEmail} width="100px" height="32px">
            Send
          </SolidButton>
        </Box>
      </ModalContainer>
      <ModalContainer display={resendEmailOkModal} modalWidth="500px">
        {isLoading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255,255,255,0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <CircularProgress sx={{ color: theme.palette.primary.mainHover }} />
          </Box>
        )}
        <Box style={{ display: "flex", justifyContent: "center" }}>
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
              letterSpacing: "-1",
            }}
          >
            Invitation Sent
          </Typography>
        </Box>
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "10px",
          }}
        >
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[3],
              fontFamily: theme.typography.fontFamily,
              textAlign: "center",
            }}
          >
            An invitation has been sent to{" "}
            <Box
              component="div"
              sx={{ fontWeight: theme.typography.customFontWeight[1] }}
            >
              {selectedRowData?.email}
            </Box>
            <div>
              Please remind the user to check their inbox and complete the
              registration process.
            </div>
          </Typography>
        </Box>

        <Box
          sx={{
            paddingTop: "30px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <SolidButton
            onClick={() => setResendEmailOkModal(false)}
            width="100px"
            height="32px"
          >
            OK
          </SolidButton>
        </Box>
      </ModalContainer>
      <ModalContainer display={actionModal} modalWidth="500px">
        <Box sx={{ textAlign: "center" }}>
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
          >
            Action denied
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography
              sx={{
                color: theme.palette.primary.black,
                fontSize: theme.typography.customFontSize[3],
                fontFamily: theme.typography.fontFamily,
                marginTop: "20px",
              }}
            >
              {errorMessage}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <SolidButton
              sx={{ marginTop: "30px" }}
              onClick={() => setActionModal(false)}
              width="100px"
              height="32px"
            >
              OK
            </SolidButton>
          </Box>
        </Box>
      </ModalContainer>
      <ErrorNotification
        open={errorMessageHandleModal}
        onClose={() => setErrorMessageHandleModal(false)}
        message={errorMessage}
      />
    </>
  );
};

export default ResendModal;
